var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_c('progress-bar', {
    attrs: {
      "percent": 20
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("Warranty contact")]), _c('div', {
    staticClass: "description"
  }, [_vm._v(" " + _vm._s(_vm.isUK ? "For warranty purposes we need the contact information for the solar energy company who is selling the system to the end customer." : "Please provide the best contact of the solar retailer or company who purchased this SolShare for warranty purposes.") + " ")]), _c('a-form-model', {
    ref: "form",
    attrs: {
      "colon": false,
      "rules": _vm.rules,
      "model": _vm.form
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "Company",
      "prop": "company"
    }
  }, [_c('a-input', {
    staticClass: "input-box",
    attrs: {
      "size": "large",
      "placeholder": "Please input company",
      "data-tn": "warranty-company"
    },
    model: {
      value: _vm.form.company,
      callback: function ($$v) {
        _vm.$set(_vm.form, "company", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.company"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "First name",
      "prop": "firstName"
    }
  }, [_c('a-input', {
    staticClass: "input-box",
    attrs: {
      "size": "large",
      "placeholder": "Please input first name",
      "data-tn": "warranty-first-name"
    },
    model: {
      value: _vm.form.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "firstName", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.firstName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Last name",
      "prop": "lastName"
    }
  }, [_c('a-input', {
    staticClass: "input-box",
    attrs: {
      "size": "large",
      "placeholder": "Please input last name",
      "data-tn": "warranty-last-name"
    },
    model: {
      value: _vm.form.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "lastName", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.lastName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Contact email",
      "prop": "contactEmail"
    }
  }, [_c('a-input', {
    staticClass: "input-box",
    attrs: {
      "size": "large",
      "placeholder": "Please input contact email",
      "data-tn": "warranty-contact-email"
    },
    model: {
      value: _vm.form.contactEmail,
      callback: function ($$v) {
        _vm.$set(_vm.form, "contactEmail", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.contactEmail"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "Contact phone",
      "prop": "contactPhone"
    }
  }, [_c('a-input', {
    staticClass: "input-box",
    attrs: {
      "size": "large",
      "placeholder": "Please input contact phone",
      "data-tn": "warranty-contact-phone"
    },
    model: {
      value: _vm.form.contactPhone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "contactPhone", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.contactPhone"
    }
  })], 1)], 1), _c('a-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('back-button', {
    style: {
      marginTop: 0
    }
  })], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('yellow-button', {
    attrs: {
      "data-tn": "warranty-submit"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" NEXT ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }